import React from 'react';
import { Typography } from '@mui/material';

export const AI_DISCLAIMER = {
  tr: 'Bu özellik yapay zekâ teknolojisi kullanmaktadır. Oluşturulan yanıtlar otomatik olarak üretilir ve hatalı veya eksik bilgiler içerebilir. Önemli bilgileri kullanmadan önce doğrulamanızı öneririz.',
  en: 'This feature uses artificial intelligence. Responses are generated automatically and may contain incorrect or incomplete information. We recommend verifying important information before using it.',
  fr: 'Cette fonctionnalité utilise l’intelligence artificielle. Les réponses sont générées automatiquement et peuvent contenir des informations incorrectes ou incomplètes. Nous vous recommandons de vérifier les informations importantes avant de les utiliser.',
};

export default function AiDisclaimer({ locale = 'tr' }) {
  return <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, lineHeight: 1.5 }}>{AI_DISCLAIMER[locale] || AI_DISCLAIMER.tr}</Typography>;
}
